import { BLOG_URL, ME_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const blogsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBlogPosts: builder.query({
      query: ({ page = 1, pageSize = 10, tag } = {}) => {
        const params = new URLSearchParams({ page, pageSize });
        if (tag) params.set('tag', tag);
        return { url: `${BLOG_URL}?${params}` };
      },
      keepUnusedDataFor: 300,
      providesTags: ['BlogPost'],
    }),
    getBlogPostBySlug: builder.query({
      query: (slug) => ({ url: `${BLOG_URL}/post/${slug}` }),
      keepUnusedDataFor: 300,
      providesTags: ['BlogPost'],
    }),
    getMyBlogPosts: builder.query({
      query: ({ page = 1, pageSize = 10 } = {}) => {
        const params = new URLSearchParams({ page, pageSize });
        return { url: `${ME_URL}/blogs?${params}` };
      },
      keepUnusedDataFor: 60,
      providesTags: ['BlogPost'],
    }),
    createBlogPost: builder.mutation({
      query: (data) => ({
        url: BLOG_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['BlogPost'],
    }),
    updateBlogPost: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${BLOG_URL}/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['BlogPost'],
    }),
    deleteBlogPost: builder.mutation({
      query: (id) => ({
        url: `${BLOG_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BlogPost'],
    }),
    uploadBlogImage: builder.mutation({
      query: (formData) => ({
        url: `${BLOG_URL}/images`,
        method: 'POST',
        body: formData,
      }),
    }),
    deleteBlogImage: builder.mutation({
      query: (imageId) => ({
        url: `${BLOG_URL}/images/${imageId}`,
        method: 'DELETE',
      }),
    }),
    adminGetAllBlogPosts: builder.query({
      query: ({ page = 1, pageSize = 10, status, keyword } = {}) => {
        const params = new URLSearchParams({ page, pageSize });
        if (status) params.set('status', status);
        if (keyword) params.set('keyword', keyword);
        return { url: `${BLOG_URL}/admin/posts?${params}` };
      },
      keepUnusedDataFor: 60,
      providesTags: ['BlogPost'],
    }),
    adminToggleFeatured: builder.mutation({
      query: (id) => ({
        url: `${BLOG_URL}/admin/${id}/feature`,
        method: 'PUT',
      }),
      invalidatesTags: ['BlogPost'],
    }),
    adminToggleRestrict: builder.mutation({
      query: (id) => ({
        url: `${BLOG_URL}/admin/${id}/restrict`,
        method: 'PUT',
      }),
      invalidatesTags: ['BlogPost'],
    }),
    adminDeleteBlogPost: builder.mutation({
      query: (id) => ({
        url: `${BLOG_URL}/admin/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BlogPost'],
    }),
  }),
});

export const {
  useGetBlogPostsQuery,
  useGetBlogPostBySlugQuery,
  useGetMyBlogPostsQuery,
  useCreateBlogPostMutation,
  useUpdateBlogPostMutation,
  useDeleteBlogPostMutation,
  useUploadBlogImageMutation,
  useDeleteBlogImageMutation,
  useAdminGetAllBlogPostsQuery,
  useAdminToggleFeaturedMutation,
  useAdminToggleRestrictMutation,
  useAdminDeleteBlogPostMutation,
} = blogsApiSlice;
